import { Card } from 'components/Card';
import type { TAltDesignations } from '@timeedit/types/lib/types';
import { AltDesignationFooter } from './AltDesignationsFooter/AltDesignationsFooter';
import { AltDesignationRow } from './AltDesignationsRow/AltDesignationsRow';
import './AltDesignationsCard.scss';

type AltDesignationsCardProps = {
  altDesignations: TAltDesignations[];
  onChange: (altDesignations: TAltDesignations[]) => void;
  title: string;
  displayDescription?: boolean;
};
export const AltDesignationsCard = ({
  altDesignations,
  onChange,
  title,
  displayDescription = false,
}: AltDesignationsCardProps) => {
  const addAltDesignation = (language: string) => {
    const newAltDesignation = {
      language,
      name: '',
      description: '',
    };
    onChange([...altDesignations, newAltDesignation]);
  };

  const removeAltDesignation = (index: number) => {
    onChange(altDesignations.filter((_, i) => i !== index));
  };

  const updateAltDesignation = (
    index: number,
    newAltDesignation: TAltDesignations
  ) => {
    const newAltDesignations = [...altDesignations];
    newAltDesignations[index] = newAltDesignation;
    onChange(newAltDesignations);
  };

  return (
    <Card
      title={title}
      tooltip="Translations"
      className="alt-designations-card"
      styles={{ body: { paddingTop: '4px' } }}
      footer={
        <AltDesignationFooter
          onClick={addAltDesignation}
          usedAltDesignations={altDesignations}
        />
      }
    >
      <div className="alt-designations-card-body">
        {altDesignations?.map((altDesignation, index) => (
          <AltDesignationRow
            key={`${altDesignation.language}-${index}`}
            altDesignation={altDesignation}
            onChange={(e) => updateAltDesignation(index, e)}
            onDelete={() => removeAltDesignation(index)}
            displayDescription={displayDescription}
          />
        ))}
      </div>
    </Card>
  );
};
